import { showBonusModal } from "@shared/actions/bonuses";
import { BonusButton } from "@shared/components";
import { useBonuses } from "@shared/hooks/bonuses/bonuses";
import { useLobbyParams } from "@shared/hooks/lobby/lobby";
import { useIsAuth } from "@shared/hooks/user";
import React from "react";
import { useDispatch } from "react-redux";

import Bottom from "./Bottom";
import Top from "./Top";

export const Header = (props) => {
  const { bonus } = useBonuses();
  const dispatch = useDispatch();
  const lobbyParams = useLobbyParams();
  const isAuth = useIsAuth();

  return (
    <header className="header">
      {isAuth && bonus && bonus.available && lobbyParams?.sweepstakes && (
        <div className="bonus-desktop-header">
          <BonusButton
            bonus={bonus}
            onClick={() => dispatch(showBonusModal())}
          />
        </div>
      )}
      <Top />
      <Bottom {...props} />
      {/*<XMasDecoration*/}
      {/*  style={{*/}
      {/*    position: "absolute",*/}
      {/*    zIndex: 1,*/}
      {/*    bottom: 0,*/}
      {/*    left: 0,*/}
      {/*    width: "100%",*/}
      {/*    height: "3rem",*/}
      {/*    transform: "translateY(2.25rem)",*/}
      {/*  }}*/}
      {/*/>*/}
      <div className="header__border" />
    </header>
  );
};
